import { GAUGE_VARIANTS } from './gaugeVariants';
import { CHART_VARIANTS } from './chartVariants';
import { EXTRA_VARIANTS } from './extraVariants';
import { METRIC_VARIANTS } from './metricVariants';
import { TABLE_VARIANTS } from './tableVariants';
import { STATUS_LIST_VARIANTS } from './statusListVariants';
import { PROGRESS_VARIANTS } from './progressVariants';

const VARIANT_FAMILIES = {
    gauge: GAUGE_VARIANTS,
    chart: CHART_VARIANTS,
    extra: EXTRA_VARIANTS,
    metric: METRIC_VARIANTS,
    table: TABLE_VARIANTS,
    'status-list': STATUS_LIST_VARIANTS,
    progress: PROGRESS_VARIANTS,
};

export function getVariantMeta(family, variantId) {
    if (!family) return null;
    return (VARIANT_FAMILIES[family] || []).find((v) => v.id === variantId) || null;
}

export default VARIANT_FAMILIES;
